import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function FinalCTA() {
  const { finalCTA } = useHomeData();
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20Yokohama%20Minato%20Mirai%20with%20landmark%20tower%20and%20ferris%20wheel%2C%20helicopter%20perspective%2C%20deep%20navy%20blue%20sky%20with%20sparkling%20city%20lights%20reflecting%20on%20water%2C%20cinematic%20luxury%20atmosphere%2C%20wide%20panoramic%20composition%2C%20no%20text%2C%208k%20quality&width=1920&height=600&seq=finalcta01&orientation=landscape"
        alt="横浜夜景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-airdoa-navy/60" />

      <div className="relative z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal direction="up">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold text-white leading-tight whitespace-pre-line">
              {finalCTA.title}
            </h2>
            <p className="mt-6 text-base text-white/70">{finalCTA.subtitle}</p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              {finalCTA.ctas.map((cta) => {
                if (cta.type === "primary") {
                  return (
                    <Link key={cta.href} to={cta.href} className="btn-primary">
                      {cta.label}
                    </Link>
                  );
                }
                if (cta.type === "secondary") {
                  return (
                    <Link key={cta.href} to={cta.href} className="btn-secondary">
                      {cta.label}
                    </Link>
                  );
                }
                return (
                  <Link key={cta.href} to={cta.href} className="btn-ghost">
                    {cta.label}
                  </Link>
                );
              })}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}